"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DisaggregationGroup = /** @class */ (function () {
    function DisaggregationGroup(groupId, name, disaggregationIds, disaggregationMetas) {
        if (disaggregationMetas === void 0) { disaggregationMetas = []; }
        this.groupId = groupId;
        this.name = name;
        this.disaggregationIds = disaggregationIds;
        this.disaggregationMetas = disaggregationMetas;
    }
    return DisaggregationGroup;
}());
exports.DisaggregationGroup = DisaggregationGroup;
var CompositeIds = /** @class */ (function () {
    function CompositeIds(compositeIds) {
        this.compositeIds = compositeIds;
    }
    Object.defineProperty(CompositeIds.prototype, "ids", {
        get: function () {
            var ids = [];
            for (var _i = 0, _a = this.compositeIds; _i < _a.length; _i++) {
                var compositeId = _a[_i];
                ids.push(compositeId.typeId ? compositeId.typeId : compositeId.id);
            }
            return ids.length > 0 ? ids : undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompositeIds.prototype, "length", {
        get: function () {
            return this.compositeIds ? this.compositeIds.length : 0;
        },
        enumerable: true,
        configurable: true
    });
    return CompositeIds;
}());
exports.CompositeIds = CompositeIds;
var CompositeId = /** @class */ (function () {
    function CompositeId(id, typeId) {
        this.typeId = typeId;
        this.id = id;
    }
    /**
     * Method return from cache CompositeId by id and typeId.
     * If in cache there isn't item for this id and typeId, method create and add in cache appropriate CompositeId, then return
     * @param {number} id Disaggregation category id
     * @param {number} typeId dynamic disaggregationTypeId
     * @returns {CompositeId} cached compositeId
     */
    CompositeId.getInstance = function (id, typeId) {
        for (var _i = 0, _a = CompositeId.cache; _i < _a.length; _i++) {
            var compositeId_1 = _a[_i];
            if (compositeId_1.id === id && compositeId_1.typeId === typeId) {
                return compositeId_1;
            }
        }
        var compositeId = new CompositeId(id, typeId);
        CompositeId.cache.push(compositeId);
        return compositeId;
    };
    /**
     * Method return from cache CompositeId by id.
     * @param typeId
     * @returns {any}
     */
    CompositeId.getInstanceByTypeId = function (typeId) {
        for (var _i = 0, _a = CompositeId.cache; _i < _a.length; _i++) {
            var compositeId = _a[_i];
            if (compositeId.typeId === typeId) {
                return compositeId;
            }
        }
        return null;
    };
    CompositeId.cache = [];
    return CompositeId;
}());
exports.CompositeId = CompositeId;
//# sourceMappingURL=disaggregation-group.model.js.map